<template>
    <div v-if="permissionCheck('Employees','Read')" class="container-fluid" style="background-color: #f8f8f8;">
        <div class="row actions">
            <div class="col-md-3 float-left">
                Home >  Employees
            </div>
            <div class="col-md-9">
                <button style="float: right; margin-left: 5px;" class="btn btn-primary" @click="$refs.searchFilter.show()"><icon name="search"></icon> Search Filter</button>
                <button v-if="permissionCheck('Employees','Create') && !selectedEmployee.name && !newEmployee" style="float: right; margin-left: 5px;" class="btn btn-success" @click="storeEmployeeStart"><icon name="plus"></icon> New User</button>
                <button v-if="selectedEmployee.name || newEmployee" style="float: right; margin-left: 5px;" class="btn btn-danger" @click="closeEmployee()"><icon name="search"></icon> Close</button>
            </div>
        </div>

        <div class="row">

            <div class="col content" v-show="!selectedEmployee.name && !newEmployee">

                <!------------------------------>
                <!--Search Filter Critera List-->
                <!------------------------------>
                <div class="row" style="background-color: rgba(0,0,0,0.03); padding: 5px;" v-if="searchFilters.isActive">
                    <div class="col-md-12" style="background-color: rgba(0,0,0,0.06); text-align: center; font-size: 18px; padding: 10px; border: 1px solid rgba(0,0,0,0.2);">
                        SEARCH CRITERIA
                    </div>

                    <div class="col-md-6" v-if="searchFilters.companies.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cost Company</strong></div>
                            <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.companies"><b-badge variant="info">{{findCompany(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.sponsorCompanies.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Sponsor Company</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.sponsorCompanies"><b-badge variant="info">{{findSponsorCompany(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.branches.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Branches</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.branches"><b-badge variant="info">{{findBranch(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.departments.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Departments</strong></div>
                            <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.departments"><b-badge variant="info">{{findDepartment(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.designations.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Designations</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.designations"><b-badge variant="info">{{findDesignation(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.religions.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white;padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Religions</strong></div>
                            <div class="col-md-8" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.religions"><b-badge variant="info">{{findReligion(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.nationalities.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Nationalities</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.nationalities"><b-badge variant="info">{{findNationality(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.cities.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Cities</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.cities"><b-badge variant="info">{{data}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.employees.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Employees</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.employees"><b-badge variant="info">{{findUser(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.shiftPlans.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Shift Plans</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="data in searchFilters.shiftPlans"><b-badge variant="info">{{findShiftPlan(data).name}}</b-badge>&nbsp;</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="searchFilters.status.length > 0">
                        <div class="row">
                            <div class="col" style="background-color: white; padding: 5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);"><strong>Status</strong></div>
                            <div class="col-md-8" style="background-color: white; padding:5px; margin: 6px; border: 1px solid rgba(0,0,0,0.2);">
                                <span v-for="statusx in searchFilters.status">
                                    <span v-html="status(statusx)"></span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding: 10px;">
                        <button style="float: right;" class="btn btn-secondary" @click="$refs.searchFilter.show()"><icon name="search"></icon> Modify Filter</button>
                        <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('employees')"><icon name="users"></icon> Search Employees</button>
                    </div>
                </div>

                <div v-if="timesheetsList.length == 0">
                    <p align="center">Currently there are no results for the requested search criteria</p>
                    <p align="center">Please use the search filter to find the records. </p>
                </div>

                <!------------------------------------------------->
                <!------------- Employee Listing Table  ----------->
                <!------------------------------------------------->

                <div v-if="timesheetsList.length > 0 && searchFilters.resultsView == 'employees'" class="row">
                    <div class="col-md-12">
                        <h2 align="center"><br/><icon name="users" scale="4"></icon> <br/> EMPLOYEES LIST</h2>
                    </div>
                    <div v-show="timesheetsListLoading" class="col-md-12">
                        <div class="row justify-content-md-center" style="width:100%;"><semipolar-spinner :animation-duration="2500" :size="200" :color="'#62a622'" ></semipolar-spinner></div>
                        <div class="row justify-content-md-center" style="width:100%; font-size: 12px;">Please Wait..</div>
                    </div>

                    <!--Tickets List Table-->
                    <table align="center" v-show="!timesheetsListLoading"  class="table table-hover shadows" style="margin-bottom: 30px; background-color: white; margin-top: 10px; width: 95%; align-content: center;">
                        <thead style="background-color: #fffaf0; font-size: 12px;">
                        <th scope="col"><span @click="sortToggle('id')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('id')"></icon></span> ID </th>
                        <th scope="col"><span @click="sortToggle('name')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('name')"></icon></span> Name</th>
                        <th scope="col">Arabic Name</th>
                        <th scope="col">Nationality</th>
                        <th scope="col">ID / Iqama #</th>
                        <th scope="col"><span @click="sortToggle('company')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('company')"></icon></span> Cost Company</th>
                        <th scope="col"><span @click="sortToggle('sponsorCompany')" style="cursor:pointer;"> &nbsp;<icon :name="sortToggleIcon('sponsorCompany')"></icon></span> Sponsor Company</th>
                        <th scope="col">Department</th>
                        <th scope="col">City</th>
                        <th scope="col">Branches</th>
                        <th scope="col">Position</th>
                        <th scope="col">Religion</th>
                        <th scope="col">Status</th>
                        </thead>

                        <tbody>
                        <tr v-for="employee in timesheetsList">
                            <td style="font-size: 12px; cursor: pointer;">{{employee.id}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectEmployee(employee)">{{employee.name}}</td>
                            <td style="font-size: 12px; cursor: pointer;" @click="selectEmployee(employee)">{{employee.name_lang}}</td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.nationality}}</td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.nationalID}}</td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.company}}</td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.sponsorCompany}}</td>
                            <td style="font-size: 12px; cursor: pointer;"><span v-for="department in employee.departments"><span v-if="findDepartment(department).name">{{findDepartment(department).name}}</span>&nbsp;</span></td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.city}}</td>
                            <td style="font-size: 12px; cursor: pointer;">
                                <span v-if="employee.branches"><span style="font-size: 12px;" v-for="branch in employee.branches" class="badge badge-light">{{findBranch(branch).name}}</span> </span>
                            </td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.designation}}</td>
                            <td style="font-size: 12px; cursor: pointer;">{{employee.religion}}</td>
                            <td style="font-size: 12px; cursor: pointer;">
                                <span v-html="status(employee.active)"></span>
                            </td>

                        </tr>
                        </tbody>
                    </table>

                    <!--Pagination Links-->
                    <div class="col-md-12 standout" v-if="timesheetsList.length > 0" v-show="!timesheetsListLoading"  >
                        <div class="row">
                            <div class="col text-left" style="padding-top: 8px; font-size: 12px;">Total: {{timesheetsPaginationObject.totalRecords}} Employees</div>
                            <div class="col text-center" style="min-width: 200px; font-size: 12px;">
                                <button @click="updateRecordsList(1)" :disabled="!timesheetsPaginationObject.firstActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"><icon name="angle-double-left"></icon></button>
                                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage-1)" :disabled="!timesheetsPaginationObject.previousActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-left"></icon> </button>
                                &nbsp; {{timesheetsPaginationObject.currentPage}} of {{timesheetsPaginationObject.totalPages}} &nbsp;
                                <button @click="updateRecordsList(timesheetsPaginationObject.currentPage+1)" :disabled="!timesheetsPaginationObject.nextActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-right"></icon> </button>
                                <button @click="updateRecordsList(timesheetsPaginationObject.totalPages)" :disabled="!timesheetsPaginationObject.lastActive" class="btn btn-sm btn-outline-dark" style="margin-right: 3px;"> <icon name="angle-double-right"></icon> </button>
                            </div>
                            <div class="col text-right" style="float:right;">
                                <select v-model="sorting.limit" class="form-control" style="max-width: 140px; float: right;">
                                    <option :value="13">13 Per Page</option>
                                    <option :value="50">50 Per Page</option>
                                    <option :value="100">100 Per Page</option>
                                    <option :value="500">500 Per Page</option>
                                    <option :value="1000">1000 Per Page</option>
                                </select>
                                <button class="btn btn-success float-right" type="submit" style="margin-right: 5px; margin-top: 5px;" @click="exportCSV('employeesCSV')"><icon name="file"></icon> Export</button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>



            <!------------------------------>
            <!-------Create Employee-------->
            <!------------------------------>
            <div class="col content" v-if="permissionCheck('Employees','Create') && newEmployee && !selectedEmployee.name">
                <form @submit.prevent="storeEmployee">
                    <div class="container shadows">
                        <div class="row" style="background-color: #f8f8f8; border-bottom: 1px solid #bababa;  padding-top: 22px;">
                            <div class="col-md-12" style="padding: 20px;">
                                <h4><icon name="user" scale="3"></icon> &nbsp; Create a New Employee</h4>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-10"><h5 style="padding: 10px 0px 20px 0px;">PERSONAL DETAILS</h5></div>
                            <div class="col-md-2"><h6 class="float-right"></h6></div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>User ID:</h6></div>
                            <div class="col-md-4">
                                <input v-on:focusout="checkEmployee" class="form-control" v-model="storeEmployeeForm.id" type="number" min="1" max="99999999999" required/>
                            </div>

                            <div class="col-md-2"><h6>Status</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.status2"
                                    @input="onSelectStatus3"
                                    :options="statuses"
                                    placeholder="Select Status"
                                    label="name" track-by="id">
                                </multiselect>

                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Name</h6></div>
                            <div class="col-md-4"><input class="form-control" v-model="storeEmployeeForm.name" type="text" required/></div>

                            <div class="col-md-2"><h6>Arabic Name</h6></div>
                            <div class="col-md-4"><input class="form-control" v-model="storeEmployeeForm.name_lang" type="text" required/></div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>National ID</h6></div>
                            <div class="col-md-4">
                                <input class="form-control" v-model="storeEmployeeForm.nationalID" type="text"/>
                            </div>

                            <div class="col-md-2"><h6>Nationality</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.nationalities2"
                                    @input="onSelectNationalities3"
                                    :options="nationalities"
                                    placeholder="Select Nationality"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>City</h6></div>
                            <div class="col-md-4">
                                <input class="form-control" v-model="storeEmployeeForm.city" type="text"/>
                            </div>

                            <div class="col-md-2"><h6>Religion</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.religions2"
                                    @input="onSelectReligions3"
                                    :options="religions"
                                    placeholder="Select Religion"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>


                        <div class="row"><div class="col-md-12"><h5 style="padding: 20px 0px 20px 0px;">COMPANY DETAILS</h5></div></div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Cost Company</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.companies2"
                                    @input="onSelectCostCompany3"
                                    :options="companies"
                                    placeholder="Select Cost Company"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>

                            <div class="col-md-2"><h6>Sponsor Company</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.sponsor_companies2"
                                    @input="onSelectSponsorCompany3"
                                    :options="companies"
                                    placeholder="Select Sponsor Company"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Branch</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.branches2"
                                    :options="branches"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder=""
                                    @input="onSelectBranches3"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col-md-2"><h6>Supervisor</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.supervisor2"
                                    @input="onSelectUser3"
                                    :options="users"
                                    placeholder="Select Supervisor"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Position</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.designations2"
                                    @input="onSelectDesignations3"
                                    :options="designations"
                                    placeholder="Select Designation"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>

                            <div class="col-md-2"><h6>Department</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="storeEmployeeForm.departments2"
                                    :options="departments"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder=""
                                    @input="onSelectDepartments3"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="row"><div class="col-md-12"><h5 style="padding: 20px 0px 20px 0px;">SECURITY DETAILS</h5></div></div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Email</h6></div>
                            <div class="col-md-4"><input class="form-control" v-model="storeEmployeeForm.email" type="email"/></div>

                            <div class="col-md-2"><h6>Password</h6></div>
                            <div class="col-md-4"><input class="form-control" v-model="storeEmployeeForm.password" type="password"/></div>
                        </div>

                        <div class="row" style="margin: 35px 0px 25px 0;">
                            <div class="col-md-12 float-right">
                                <button style="float: right; margin-left: 5px;" type="submit" class="btn btn-primary"><icon name="save"></icon> Create Employee</button>
                                <button v-if="selectedEmployee.name || newEmployee" style="float: right; margin-left: 5px;" class="btn btn-danger" @click="closeEmployee()"><icon name="search"></icon> Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>


            <!------------------------------>
            <!------- Update Profile-------->
            <!------------------------------>
            <div class="col content" v-if="selectedEmployee.name && searchFilters.resultsView == 'employees'">
                <form @submit.prevent="updateEmployee">
                    <div class="container shadows">

                        <div class="row" style="background-color: #f8f8f8; border-bottom: 1px solid #bababa;  padding-top: 22px;">
                            <div class="col-md-1" style="padding: 20px;">
                                <icon name="user" scale="6"></icon>
                            </div>
                            <div class="col-md-10" style="padding: 20px;">
                                <h4>{{selectedEmployee.name}}</h4>
                                <h5>{{selectedEmployee.designation.name}} - {{selectedEmployee.company.name}}</h5>
                                <span v-html="status(selectedEmployee.active)"></span>
                            </div>
                            <div class="col-md-1">
                                <button v-if="selectedEmployee.name && permissionCheck('Employees','Delete')" style="float: right; margin-left: 5px;" class="btn btn-danger" @click="deleteEmployee(selectedEmployee.id)"><icon name="times"></icon> Delete</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-10"><h5 style="padding: 10px 0px 20px 0px;">PERSONAL DETAILS</h5></div>
                            <div class="col-md-2"><h6 class="float-right">USER ID: {{user.id}}</h6></div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Name</h6></div>
                            <div class="col-md-4"><input :disabled="disabled" class="form-control" v-model="updateEmployeeForm.name" type="text"/></div>

                            <div class="col-md-2"><h6>Arabic Name</h6></div>
                            <div class="col-md-4"><input :disabled="disabled" class="form-control" v-model="updateEmployeeForm.name_lang" type="text"/></div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>National ID</h6></div>
                            <div class="col-md-4">
                                <input :disabled="disabled" class="form-control" v-model="updateEmployeeForm.nationalID" type="text"/>
                            </div>

                            <div class="col-md-2"><h6>Nationality</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.nationalities2"
                                    :disabled="disabled"
                                    @input="onSelectNationalities2"
                                    :options="nationalities"
                                    placeholder="Select Nationality"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>City</h6></div>
                            <div class="col-md-4">
                                <input :disabled="disabled" class="form-control" v-model="updateEmployeeForm.city" type="text"/>
                            </div>

                            <div class="col-md-2"><h6>Religion</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.religions2"
                                    :disabled="disabled"
                                    @input="onSelectReligions2"
                                    :options="religions"
                                    placeholder="Select Religion"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>


                        <div class="row"><div class="col-md-12"><h5 style="padding: 20px 0px 20px 0px;">COMPANY DETAILS</h5></div></div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Cost Company</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.companies2"
                                    :disabled="disabled"
                                    @input="onSelectCostCompany2"
                                    :options="companies"
                                    placeholder="Select Cost Company"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>

                            <div class="col-md-2"><h6>Sponsor Company</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.sponsor_companies2"
                                    :disabled="disabled"
                                    @input="onSelectSponsorCompany2"
                                    :options="companies"
                                    placeholder="Select Sponsor Company"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Branch</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="user.branches2"
                                    :disabled="disabled"
                                    :options="branches"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder=""
                                    @input="onSelectBranches2"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col-md-2"><h6>Supervisor</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.supervisor2"
                                    :disabled="disabled"
                                    @input="onSelectUser2"
                                    :options="users"
                                    placeholder="Select Supervisor"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Position</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.designations2"
                                    :disabled="disabled"
                                    @input="onSelectDesignations2"
                                    :options="designations"
                                    placeholder="Select Designation"
                                    label="name" track-by="id">
                                </multiselect>
                            </div>

                            <div class="col-md-2"><h6>Department</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="user.departments2"
                                    :disabled="disabled"
                                    :options="departments"
                                    :multiple="true"
                                    :close-on-select="true"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder=""
                                    @input="onSelectDepartments2"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="row"><div class="col-md-12"><h5 style="padding: 20px 0px 20px 0px;">SECURITY DETAILS</h5></div></div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Email</h6></div>
                            <div class="col-md-4"><input :disabled="disabled" class="form-control" v-model="updateEmployeeForm.email" type="email"/></div>

                            <div v-if="adminCheck && !disabled" class="col-md-2"><h6>Password</h6></div>
                            <div v-if="adminCheck && !disabled" class="col-md-4"><input class="form-control" v-model="updateEmployeeForm.password" type="password"/></div>
                        </div>

                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-md-2"><h6>Status</h6></div>
                            <div class="col-md-4">
                                <multiselect
                                    v-model="updateEmployeeForm.status2"
                                    @input="onSelectStatus2"
                                    :disabled="disabled"
                                    :options="statuses"
                                    placeholder="Select Status"
                                    label="name" track-by="id">
                                </multiselect>

                            </div>

                            <div class="col-md-2"><h6></h6></div>
                            <div class="col-md-4"></div>
                        </div>

                        <div class="row" style="margin: 35px 0px 25px 0;">
                            <div class="col-md-12 float-right">
                                <button v-if="permissionCheck('Employees','Update')" :disabled="disabled" style="float: right; margin-left: 5px;" type="submit" @click="updateEmployee1" class="btn btn-primary"><icon name="save"></icon> Update Details</button>
                                <button v-if="selectedEmployee.name" style="float: right; margin-left: 5px;" class="btn btn-danger" @click="closeEmployee()"><icon name="search"></icon> Close / Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Search Filter Modal -->
            <form @submit.prevent="onSearchFilters">
                <b-modal ref="searchFilter" size="lg" centered >
                    <div slot="modal-header">
                        <h3>Time and Attendance: Search Filter</h3>
                    </div>

                    <b-container fluid>

                        <div class="form-group row">
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Cost Company</strong></small>
                                <multiselect
                                        v-model="searchFilters.companies2"
                                        :options="companies"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectCostCompany"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col">
                                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Sponsor Company</strong></small>
                                <multiselect
                                        v-model="searchFilters.sponsorCompanies2"
                                        :options="sponsorCompanies"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectSponsorCompany"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Branch</strong></small>
                                <multiselect
                                        v-model="searchFilters.branches2"
                                        :options="branches"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectBranches"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col">
                                <small class="form-text text-muted"> <icon name="list"></icon> <strong>Departments</strong></small>
                                <multiselect
                                        v-model="searchFilters.departments2"
                                        :options="departments"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectDepartments"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="map-pin"></icon> <strong>City</strong></small>
                                <multiselect
                                        v-model="searchFilters.cities2"
                                        :options="cities"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectCities"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col">
                                <small class="form-text text-muted"> <icon name="globe"></icon> <strong>Nationality</strong></small>
                                <multiselect
                                        v-model="searchFilters.nationalities2"
                                        :options="nationalities"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectNationalities"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="briefcase"></icon> <strong>Designation</strong></small>
                                <multiselect
                                        v-model="searchFilters.designations2"
                                        :options="designations"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectDesignations"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col">
                                <small class="form-text text-muted"> <icon name="book"></icon> <strong>Religion</strong></small>
                                <multiselect
                                        v-model="searchFilters.religions2"
                                        :options="religions"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectReligions"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>

                        <div class="form-group row">

                            <div class="col">
                                <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee</strong></small>
                                <multiselect
                                        v-model="searchFilters.employees2"
                                        :options="users"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder="Search By Name"
                                        @input="onSelectUsers"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.id }} - {{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.id }} - {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="users"></icon> <strong>Employee</strong></small>
                                <multiselect
                                        v-model="searchFilters.employees2"
                                        :options="users"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder="Search By ID"
                                        @input="onSelectUsers"
                                        label="id"
                                        track-by="id"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        {{ props.option.id }}
                                        <!--                                        <span> - {{ props.option.name }}</span>-->
                                        <!--                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>-->
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.id }} - {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="refresh"></icon> <strong>Shift Plan</strong></small>
                                <multiselect
                                        v-model="searchFilters.shiftPlans2"
                                        :options="shiftPlans"
                                        :multiple="true"
                                        :close-on-select="false"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        placeholder=""
                                        @input="onSelectShiftPlans"
                                        label="name"
                                        track-by="name"
                                        :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="refresh"></icon> <strong>No Shifts</strong></small>
                                <input type="checkbox" v-model="searchFilters.noShiftPlans">
                            </div>
                            <div class="col">
                                <small class="form-text text-muted"> <icon name="building"></icon> <strong>Status</strong></small>
                                <multiselect
                                    v-model="searchFilters.status2"
                                    :options="statuses"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="true"
                                    :hide-selected="true"
                                    :preserve-search="true"
                                    placeholder=""
                                    @input="onSelectStatus"
                                    label="name"
                                    track-by="name"
                                    :preselect-first="false">
                                    <template slot="tag" slot-scope="props">
                                    <span class="custom__tag">
                                        <span>{{ props.option.name }}</span>
                                        <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                                    </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        {{ props.option.name }}
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </b-container>

                    <div slot="modal-footer">
                        <button class="btn btn-success float-right" type="submit" style="margin-right: 5px;" @click="searchFilterRecords('employees')"><icon name="users"></icon> Search Employees</button>
                        <button class="btn btn-dark float-right" type="reset" style="margin-right: 5px;" @click="searchFilterClear('open')"><icon name="minus-square"></icon> Clear Filters</button>
                        <button class="btn btn-danger-outline float-right" type="button" style="margin-right: 5px;" @click="$refs.searchFilter.hide()"><icon name="times"></icon> Cancel</button>
                    </div>
                </b-modal>
            </form>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import router from './../../../router'
    import {Form, Errors} from '@/components/validations/forms';
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        name: 'Dashboard',
        components: {},
        data () {
            return {
                disabled: true,
                menuItems: [
                    {name: 'Timesheet & Attendance', link:'', icon: 'calendar', toggle: false, children: [
                            {name: 'Search Timesheet', link:'/hr/employees/search-attendance', icon: ''},
                            {name: 'Missed Punches', link:'/hr/employees/search-attendance#1', icon: ''},
                            {name: 'Absent Employees', link:'/hr/employees/search-attendance#2', icon: ''},
                        ]},
                ],
                // Loaders
                timesheetsListLoading: false,
                timesheetsDetailsLoading: false,

                toggle: {
                    leftNavigation : true,
                    rightNavigation : true,
                },

                companies: this.$store.getters['environment/getCompanies'],
                sponsorCompanies: this.$store.getters['environment/getSponsorCompanies'],
                divisions: this.$store.getters['environment/getDivisions'],
                branches: this.$store.getters['environment/getBranches'],
                departments: this.$store.getters['environment/getDepartments'],
                designations: this.$store.getters['environment/getDesignations'],
                religions: this.$store.getters['environment/getReligions'],
                nationalities: this.$store.getters['environment/getNationalities'],
                groups: this.$store.getters['environment/getGroups'],
                cities: this.$store.getters['environment/getCities'],
                users: this.$store.getters['user/getUsers'],
                shiftPlans: this.$store.getters['shifts/getShiftPlans'],
                user: null,

                // Timesheet List Related
                timesheetsList: [],
                timesheetsPages: null,
                timesheetsPaginationObject: {
                    totalRecords : 0,
                    totalPages : 0,
                    currentPage : 0,
                    first : 0,
                    firstActive : false,
                    previous : 0,
                    previousActive : false,
                    next : 0,
                    nextActive : false,
                    last : 0,
                    lastActive : false,
                },
                searchFilters: this.$store.getters['employees/getSearchFilters'],
                sorting: this.$store.getters['employees/getSorting'],
                dropdownx: this.$route.hash.substring(1),
                resultsView: "employees",

                selectedEmployee: {},
                selectedAttendance: {
                    pUnknown: [],
                },
                companies2: [],
                companies3: [],
                newEmployee: false,

                // Forms
                storeEmployeeForm: new Form({
                    id: null,
                    companies_id: null,
                    sponsor_companies_id: null,
                    designations_id: null,
                    nationalities_id: null,
                    religions_id: null,
                    name: null,
                    name_lang: null,
                    nationalID: null,
                    city: null,
                    supervisor: null,
                    email: null,
                    password: null,
                    status: null,
                    branches: [],
                    designations: [],
                    departments: [],
                    supervisor2: {},
                    companies2: {},
                    sponsor_companies2: {},
                    designations2: {},
                    nationalities2: {},
                    religions2: {},
                    status2: null,
                }),

                updateEmployeeForm: new Form({
                    id: null,
                    companies_id: null,
                    sponsor_companies_id: null,
                    designations_id: null,
                    nationalities_id: null,
                    religions_id: null,
                    name: null,
                    name_lang: null,
                    nationalID: null,
                    city: null,
                    supervisor: null,
                    email: null,
                    password: null,
                    status: null,
                    branches: [],
                    designations: [],
                    departments: [],
                    supervisor2: {},
                    companies2: {},
                    sponsor_companies2: {},
                    designations2: {},
                    nationalities2: {},
                    religions2: {},
                    status2: null,
                }),
            }
        },
        methods: {

            ////////////////////////////////////
            ////
            ///////////////////////////////////

            ////////////////////////////////////////////////////
            // Multi List Dropdown Cleanup Functions Based
            ////////////////////////////////////////////////////
            // These methods clean up objects of selected options and make an array of IDs in search filter form
            onSelectCostCompany(value){this.searchFilters.companies = value.map(a => a.id);},
            onSelectSponsorCompany(value){this.searchFilters.sponsorCompanies = value.map(a => a.id);},
            onSelectBranches(value){this.searchFilters.branches = value.map(a => a.id);},
            onSelectDepartments(value){this.searchFilters.departments = value.map(a => a.id);},
            onSelectCities(value){this.searchFilters.cities = value.map(a => a.name);},
            onSelectNationalities(value){this.searchFilters.nationalities = value.map(a => a.id);},
            onSelectDesignations(value){this.searchFilters.designations = value.map(a => a.id);},
            onSelectReligions(value){this.searchFilters.religions = value.map(a => a.id);},
            onSelectShiftPlans(value){this.searchFilters.shiftPlans = value.map(a => a.id);},
            onSelectUsers(value){this.searchFilters.employees = value.map(a => a.id);},


            onSelectBranches2(value){this.updateEmployeeForm.branches = value.map(a => a.id);},
            onSelectDesignations2(value){this.updateEmployeeForm.designations_id = value.id; this.updateEmployeeForm.designations2 = value;},
            onSelectDepartments2(value){this.updateEmployeeForm.departments = value.map(a => a.id);},
            onSelectCostCompany2(value){
                if(value){this.updateEmployeeForm.companies_id = value.id; this.updateEmployeeForm.companies2 = value;}
                else{this.updateEmployeeForm.companies_id = null; this.updateEmployeeForm.companies2 = null;}
            },
            onSelectSponsorCompany2(value){
                if(value){this.updateEmployeeForm.sponsor_companies_id = value.id; this.updateEmployeeForm.sponsor_companies2 = value;}
                else{this.updateEmployeeForm.sponsor_companies_id = null; this.updateEmployeeForm.sponsor_companies2 = null;}
            },
            onSelectCities2(value){this.updateEmployeeForm.cities = value;},
            onSelectNationalities2(value){
                if(value){this.updateEmployeeForm.nationalities_id = value.id; this.updateEmployeeForm.nationalities2 = value;}
                else{this.updateEmployeeForm.nationalities_id = null; this.updateEmployeeForm.nationalities2 = null;}
            },
            onSelectReligions2(value){
                if(value){this.updateEmployeeForm.religions_id = value.id; this.updateEmployeeForm.religions2 = value;}
                else{this.updateEmployeeForm.religions_id = null; this.updateEmployeeForm.religions2 = null;}
                },
            onSelectStatus(value){this.searchFilters.status = value.map(a => a.id);},
            onSelectStatus2(value){if(value){this.updateEmployeeForm.status = value.id;}},
            onSelectStatus3(value){if(value){this.storeEmployeeForm.status = value.id;}},
            onSelectBranches3(value){this.storeEmployeeForm.branches = value.map(a => a.id);},
            onSelectDesignations3(value){
                if(value){this.storeEmployeeForm.designations_id = value.id; this.storeEmployeeForm.designations2 = value;}
                else{this.storeEmployeeForm.designations_id = null; this.storeEmployeeForm.designations2 = null;}
            },
            onSelectDepartments3(value){this.storeEmployeeForm.departments = value.map(a => a.id);},
            onSelectCostCompany3(value){
                if(value){this.storeEmployeeForm.companies_id = value.id; this.storeEmployeeForm.companies2 = value;}
                else{this.storeEmployeeForm.companies_id = null; this.storeEmployeeForm.companies2 = null;}
            },
            onSelectSponsorCompany3(value){
                if(value){this.storeEmployeeForm.sponsor_companies_id = value.id; this.storeEmployeeForm.sponsor_companies2 = value;}
                else{this.storeEmployeeForm.sponsor_companies_id = null; this.storeEmployeeForm.sponsor_companies2 = null;}
            },
            onSelectCities3(value){this.storeEmployeeForm.cities = value;},
            onSelectNationalities3(value){
                if(value){this.storeEmployeeForm.nationalities_id = value.id; this.storeEmployeeForm.nationalities2 = value;}
                else{this.storeEmployeeForm.nationalities_id = null; this.storeEmployeeForm.nationalities2 = null;}
            },
            onSelectReligions3(value){
                if(value){this.storeEmployeeForm.religions_id = value.id; this.storeEmployeeForm.religions2 = value;}
                else{this.storeEmployeeForm.religions_id = null; this.storeEmployeeForm.religions2 = null;}
            },
            onSelectUser2(value) {
                if (value) {this.updateEmployeeForm.supervisor = value.id; this.updateEmployeeForm.supervisor2 = value;}
                else {this.updateEmployeeForm.supervisor = null; this.updateEmployeeForm.supervisor2 = null;}
            },
            onSelectUser3(value){
                if(value){this.storeEmployeeForm.supervisor = value.id; this.storeEmployeeForm.supervisor2 = value;}
                else{this.storeEmployeeForm.supervisor = null; this.storeEmployeeForm.supervisor2 = null;}
            },

            checkEmployee(){
              if(this.storeEmployeeForm.id){
                  this.$store.dispatch('user/fetchUser2', this.storeEmployeeForm)
                      .then(response => {
                          this.selectEmployee(response)
                      })
                      .catch(error => {
                          this.storeEmployeeForm.onFail(error);
                          this.$snotify.error(this.storeEmployeeForm.errors.error.message, this.storeEmployeeForm.errors.error.title);
                      })
              }
            },
            ///////////////////////////////////////
            // Search Filter Functions
            ///////////////////////////////////////
            // This method clears the search filter popup and fetches in new records based on criteria
            searchFilterRecords(view){
                this.searchFilters.resultsView = 'employees';
                this.searchFilters.isActive = true;
                this.$refs.searchFilter.hide();
                this.updateRecordsList();
            },
            // This method clears the search filter results and selected criteria load default open tickets page
            searchFilterClear(redirect){
                this.searchFilters = null;
                this.searchFilters = JSON.parse(JSON.stringify(this.$store.getters['employees/getDefaultSearchFilters']));
                this.$store.dispatch('employees/resetSearchFilters');
                this.dateSelect = {};
                this.multiselect = {};
                this.searchFilters.isActive = false;
                this.timesheetsList = [];
                this.$forceUpdate();
                this.$refs.searchFilter.hide()
            },
            // This method will perform functions once the search filter form is submitted.
            onSearchFilters(){
                //
            },



            ////////////////////////////////////////////////////////////////////////
            // Helper functions to select the objects by searching through ID
            ////////////////////////////////////////////////////////////////////////


            ///////////////////////////////////
            // General Helper Functions
            ///////////////////////////////////
            // Method to control the visibility of different sections of the page based on several criteria
            visibility(postionName){
                if(postionName === 'leftNavigation')
                {
                    if(this.iScreen(['lg','md']) && this.toggle.leftNavigation){return true;}
                }
                if(postionName === 'leftNavigationCollapsed')
                {
                    if(this.iScreen(['lg','md']) && !this.toggle.leftNavigation){return true;}
                }
                if(postionName === 'rightToolsTicket')
                {
                    if(this.iScreen(['lg','md']) && this.selectedTicket && this.toggle.rightNavigation){return true;}
                }
                if(postionName === 'leftListTicketsHeading')
                {
                    if(this.iScreen(['md']) && this.selectedTicket && !this.toggle.leftNavigation){return true;}
                    if(this.iScreen(['lg']) && this.selectedTicket) {return true;}
                }
                if(postionName === 'leftListTickets')
                {
                    if(this.iScreen(['md']) && this.selectedTicket && !this.toggle.leftNavigation){return true;}
                    if(this.iScreen(['lg']) && this.selectedTicket) {return true;}
                }
                if(postionName === 'ticketList')
                {
                    if(!this.selectedTicket){return true;}
                }
                if(postionName === 'ticketDetail')
                {
                    if(this.selectedTicket){return true;}
                }
                if(postionName === 'search')
                {
                    if(!this.selectedTicket && this.$route.hash.substring(1) === 'search'){return true;}
                }
                return false;
            },
            // This method changes true/false visibility of sections (shrink/expand) or (show/hide)
            toggleSection(sectionName){
                if(sectionName === 'leftNavigation'){this.toggle.leftNavigation = !this.toggle.leftNavigation}
                if(sectionName === 'rightNavigation'){this.toggle.rightNavigation = !this.toggle.rightNavigation}
            },
            // Helper function to sort an array by the key, like sortOrder.
            sortByKey(array, key) {
                return array.sort(function(a, b) {
                    let x = a[key]; let y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            // Update Tickets Pagination Object
            updateTicketsPaginationObject(){
                let paginationObject = null;

                let totalRecords = 0;
                let totalPages = 1;
                let currentPage = 1;
                let first = 1;
                let firstActive = false;
                let previous = 1;
                let previousActive = false;
                let next = 1;
                let nextActive = false;
                let last = 1;
                let lastActive = false;

                if(this.timesheetsPages['meta']){paginationObject = this.timesheetsPages['meta'];}
                if(paginationObject){
                    totalRecords = paginationObject.total;
                    totalPages = paginationObject.last_page;
                    currentPage = paginationObject.current_page;
                    first = 1;
                    if(currentPage > 1){previous = currentPage - 1;} else{previous = 1}
                    if(currentPage < totalPages){next = currentPage + 1;} else{next = totalPages}
                    last = paginationObject.last_page;

                    if(totalPages === 1){firstActive = false; previousActive = false; nextActive = false; lastActive = false;}
                    else{
                        if(currentPage > previous){firstActive = true; previousActive = true;}
                        if(currentPage < next){nextActive = true; lastActive = true;}
                        if(currentPage < next && currentPage > previous){firstActive = true; previousActive = true; nextActive = true; lastActive = true;}
                        if(currentPage === first){firstActive = false; previousActive = false; nextActive = true; lastActive = true;}
                        if(currentPage === last){firstActive = true; previousActive = true; nextActive = false; lastActive = false;}

                    }
                }

                this.timesheetsPaginationObject = {
                    totalRecords: totalRecords,
                    totalPages: totalPages,
                    currentPage: currentPage,
                    first: first,
                    firstActive: firstActive,
                    previous: previous,
                    previousActive: previousActive,
                    next: next,
                    nextActive: nextActive,
                    last: last,
                    lastActive: lastActive,
                };
            },

            // Sorting Columns
            sortToggle(columnID){
                if(this.sorting.sortBy === columnID){
                    if(this.sorting.sortOrder === 'desc'){this.sorting.sortOrder = 'asc';}
                    else if(this.sorting.sortOrder === 'asc'){this.sorting.sortOrder = 'desc';}
                } else{
                    this.sorting.sortBy = columnID;
                    this.sorting.sortOrder = 'asc';
                }
                this.updateRecordsList();
            },
            sortToggleIcon(columnID){
                let icon = 'sort';
                if(this.sorting.sortBy === columnID){
                    if(this.sorting.sortOrder === 'asc'){icon = 'sort-up';}
                    if(this.sorting.sortOrder === 'desc'){icon = 'sort-down';}
                }
                return icon;
            },


            //////////////////////////////////
            //     Users Attendance List   ///
            //////////////////////////////////

            // This method will be triggered whenever tickets list array needs to fetch in fresh tickets from the server
            updateRecordsList(page){
                this.selectedEmployee = {};
                this.timesheetsListLoading = true;
                if(!page){page = 1;}
                this.sorting.page = page;

                // if(this.searchFilters.isActive){
                this.$store.dispatch('employees/fetchTimesheetUsers', {filters: this.searchFilters, sorting: this.sorting})
                    .then(response => {
                        this.timesheetsList = this.$store.getters['employees/getTimesheetUsers'];
                        this.timesheetsPages = this.$store.getters['employees/getTimesheetPages'];
                        this.timesheetsListLoading = false;
                        this.updateTicketsPaginationObject();

                    })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    })
                // }
            },

            selectEmployee(employeeObject){
                this.$store.dispatch('user/fetchUser', employeeObject)
                    .then(response => {
                        this.user = this.$store.getters['user/getUser'];
                        this.selectedEmployee = this.user;
                        this.storeEmployeeForm = {};
                        this.newEmployee = false;
                        if(this.permissionCheck('Employees','Update')){this.disabled = false;}

                        // Setup Employee Update Form
                        this.updateEmployeeForm.id = this.$store.getters['user/getUser'].id;
                        this.updateEmployeeForm.companies_id = this.$store.getters['user/getUser'].company.id;
                        this.updateEmployeeForm.sponsor_companies_id = this.$store.getters['user/getUser'].sponsorCompany.id;
                        this.updateEmployeeForm.name = this.$store.getters['user/getUser'].name;
                        this.updateEmployeeForm.name_lang = this.$store.getters['user/getUser'].name_lang;
                        this.updateEmployeeForm.nationalID = this.$store.getters['user/getUser'].nationalID;
                        this.updateEmployeeForm.designations_id = this.$store.getters['user/getUser'].designation.id;
                        this.updateEmployeeForm.nationalities_id = this.$store.getters['user/getUser'].nationality.id;
                        this.updateEmployeeForm.religions_id = this.$store.getters['user/getUser'].religion.id;
                        this.updateEmployeeForm.city = this.$store.getters['user/getUser'].city;
                        this.updateEmployeeForm.supervisor = this.$store.getters['user/getUser'].supervisor;
                        this.updateEmployeeForm.email = this.$store.getters['user/getUser'].email;
                        this.updateEmployeeForm.password = null;
                        this.updateEmployeeForm.supervisor2 = this.findUser(this.updateEmployeeForm.supervisor)
                        this.updateEmployeeForm.companies2 = this.findCompany(this.updateEmployeeForm.companies_id)
                        this.updateEmployeeForm.sponsor_companies2 = this.findCompany(this.updateEmployeeForm.sponsor_companies_id)
                        this.updateEmployeeForm.designations2 = this.findDesignation(this.updateEmployeeForm.designations_id)
                        this.updateEmployeeForm.nationalities2 = this.findNationality(this.updateEmployeeForm.nationalities_id)
                        this.updateEmployeeForm.religions2 = this.findReligion(this.updateEmployeeForm.religions_id)
                        this.updateEmployeeForm.status = this.selectedEmployee.active
                        this.updateEmployeeForm.status2 = this.findStatus(this.selectedEmployee.active)
                    })
            },

            closeEmployee() {
                this.selectedEmployee = {};
                this.updateEmployeeForm = {};
                this.newEmployee = false;
                this.user = null;
            },

            storeEmployeeStart(){
                this.newEmployee = true;
                this.selectedEmployee = {};
                this.updateEmployeeForm = {};
                this.user = null;
            },

            storeEmployee(){
                this.$store.dispatch('employees/storeEmployee', this.storeEmployeeForm)
                    .then(response => {
                        this.selectEmployee(response.data)
                        this.updateRecordsList(this.timesheetsPaginationObject.currentPage);
                        this.$snotify.success('Employee Stored Succussfully');
                    })
                    .catch(error => {
                        this.storeEmployeeForm.onFail(error);
                        this.$snotify.error(this.storeEmployeeForm.errors.error.message, this.storeEmployeeForm.errors.error.title);
                    })
            },
            deleteEmployee(id){
                if(confirm("Do you really want to delete?")) {
                    this.$store.dispatch('employees/deleteUser', id)
                        .then(response => {
                            this.updateRecordsList(this.timesheetsPaginationObject.currentPage);
                            this.$snotify.success('Employee Deleted Successfully');
                        })
                        .catch(error => {
                            s
                            this.storeEmployeeForm.onFail(error);
                            this.$snotify.error(this.storeEmployeeForm.errors.error.message, this.storeEmployeeForm.errors.error.title);
                        })
                }
            },

            // Updates the Full Employee Data
            updateEmployee(employeeID){
                if(employeeID > 0 && this.timesheetsList.length > 0){
                    let currentID = employeeID;
                    let currentPosition = this.timesheetsList.map(function(e) { return e.id; }).indexOf(currentID);
                    if(currentPosition > -1){
                        // Update Employee Data
                        this.$store.dispatch('employees/fetchTimesheetUser', {
                            dateFrom: this.searchFilters.dateFrom,
                            dateTo: this.searchFilters.dateTo,
                            employees: [employeeID],
                        })
                            .then(response => {
                                if(response){
                                    if(response.length > 0){
                                        this.timesheetsList[currentPosition] = response[0];
                                        this.selectedEmployee = response[0];
                                    }
                                }
                            })
                            .catch(error => {
                                // alert(JSON.stringify(error))
                            })
                    }
                }
            },

            updateEmployee1(){
                this.$store.dispatch('employees/updateEmployee', this.updateEmployeeForm)
                    .then(response => {
                        this.selectEmployee(response.data)
                        this.updateRecordsList(this.timesheetsPaginationObject.currentPage);
                        this.$snotify.success('Employee Updated Succussfully');
                    })
                    .catch(error => {
                        this.updateEmployeeForm.onFail(error);
                        this.$snotify.error(this.updateEmployeeForm.errors.error.message, this.updateEmployeeForm.errors.error.title);
                    })
            },

            exportCSV(view){
                this.timesheetsListLoading = true;
                return axios.request({
                    method: 'GET',
                    responseType: 'blob',
                    url: '/api/attendance/user',
                    params: {
                        companies: this.searchFilters.companies,
                        sponsorCompanies: this.searchFilters.sponsorCompanies,
                        branches: this.searchFilters.branches,
                        departments: this.searchFilters.departments,
                        cities: this.searchFilters.cities,
                        nationalities: this.searchFilters.nationalities,
                        designations: this.searchFilters.designations,
                        religions: this.searchFilters.religions,
                        shiftPlans: this.searchFilters.shiftPlans,
                        dateFrom: this.searchFilters.dateFrom,
                        dateTo: this.searchFilters.dateTo,
                        employees: this.searchFilters.employees,
                        status: this.searchFilters.status,
                        noShiftPlans: this.searchFilters.noShiftPlans,
                        resultsView: view, 
                        limit: this.sorting.limit,
                        page: this.sorting.page,
                        sortBy: this.sorting.sortBy,
                        sortOrder: this.sorting.sortOrder,
                    },

                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Timesheet Report ('+this.searchFilters.dateFrom+' - '+this.searchFilters.dateTo+').csv');
                    document.body.appendChild(link);
                    link.click();
                    this.timesheetsListLoading = false;

                })
                    .catch(error => {
                        this.timesheetsListLoading = false;
                    });
            },
            loadAttendanceData() {
                //
            },
        },

        computed: {
            // React to Page limit changes in sorting
            pageLimit(){
                return this.$store.getters['employees/getSorting'].limit;
            },

            // New Overtime time
            newOvertime(){
                if(this.selectedAttendance && this.updateMissingOvertime)
                {
                    return parseInt(this.selectedAttendance.oc) + parseInt(this.updateMissingOvertime.adjustedOvertime)
                }
            },
        },

        mounted() {
            if(location.hash){this.selectEmployee({id: location.hash.substring(1)})}
        },

        created() {
            this.loadAttendanceData();
            this.updateRecordsList();
            return this.iShowCollapse(this.menuItems)
        },

        watch: {
            $route(to, from) {
                return this.iShowCollapse(this.menuItems)
            },
            // Watch Pagination Changes
            timesheetsPages: function(newValue, oldValue){
                if(newValue){this.updateTicketsPaginationObject();}
            },
            pageLimit(newValue, oldValue){
                if(newValue !== oldValue){this.updateRecordsList();}
            },
            $route(to, from) {
                // if(from.hash === '#search'){this.searchFilterClear();}
                // if(to.hash === '#search'){} else{this.updateTicketsList();}
                if(from.hash !== to.hash){this.selectEmployee({id: to.hash.substring(1)})}
            },
        },

        beforeDestroy: function(){
//      clearInterval(this.interval);
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/hr/employees/employees.vue